import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import loadable from "@loadable/component";
import pMinDelay from "p-min-delay";
import { useDispatch, useSelector } from 'react-redux';
import { setInvoiceListTab } from '../../../feature/authSlice';
import { getTotalAgreementExpireApi } from '../../../service/dashboardApi/getTotalAgreementExpiredApi';
import { getTotalHighestPaidInvoiceApi } from '../../../service/dashboardApi/getTotalHighestPaidInvoiceApi';
import {getTotalInvoiceOverdueApi} from '../../../service/dashboardApi/getTotalInvoiceOverdueApi';
import {getTotalPayableApi} from '../../../service/dashboardApi/getTotalPayableApi';
import {getTotalPayout6MonthApi} from '../../../service/dashboardApi/getTotalPayout6MonthApi';
import {getTotalPayoutApi} from '../../../service/dashboardApi/getTotalPayoutApi';
import {getTotalPendingForApprovalApi} from '../../../service/dashboardApi/getTotalPendingForApproval';
import { currencyFormat } from '../../../function/commonFunction';
import Graph from '../chartComponent/graph';
import { setPropertyRegData } from '../../../feature/propertyRegistrationSlice';
import Grid from '@mui/material/Grid';
import { Box } from '@mui/material';

//import { data } from '../../pages/WidgetBasic/ActiveUser';
//import WidgetChartIndex3 from './Index3/WidgetChartIndex3';
//import StockChartIndex3 from './Index3/StockChartIndex3';


const WidgetChartIndex3 = loadable(() =>
    pMinDelay(import("./Index3/WidgetChartIndex3"), 1000)
);
const StockChartIndex3 = loadable(() =>
    pMinDelay(import("./Index3/StockChartIndex3"), 1000)
);

const ApexLine5 = loadable(() =>
    pMinDelay(import("../../components/charts/apexcharts/Line5"), 1000)
);


const tableData = [
    { number: '55542545', title: '1.48586 ', time: '5m', status: 'Confirmed', statusColor: 'label-success' },
    { number: '65432187', title: '2.12389 ', time: '4m', status: 'Unconfirmed', statusColor: 'label-warning' },
    { number: '78954123', title: '3.65412 ', time: '6m', status: 'Canceled', statusColor: 'label-danger' },
    { number: '55542545', title: '1.48586 ', time: '5m', status: 'Confirmed', statusColor: 'label-success' },
    { number: '65432187', title: '2.12389 ', time: '4m', status: 'Unconfirmed', statusColor: 'label-warning' },

];

const Dashboard3 = () => {
    const { permissionArr } = useSelector((state) => state.auth);
    const { permissions } = useSelector((state) => state.permissionsData);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [totalPayable,setTotalPayable] = useState("")
    const [totalPayout,setTotalPayout] = useState("")

    const [totalinvoiceOverdue,setTotalInvoiceOverdue] = useState("")

    const [totalPendingForApproval,setTotalPendingForApproval] = useState("")
const [categories,setCategories] = useState([])
const[months,setMonths] = useState([])

const amounts = [];




    useEffect(()=>{

        var data ={

        }

        


        dispatch(getTotalPayableApi(data,(res)=>{ setTotalPayable(res.data.result)},()=>{}))
        dispatch(getTotalPendingForApprovalApi(data,(res)=>{ setTotalPendingForApproval(res.data.result)},()=>{}))
        dispatch(getTotalPayoutApi(data,(res)=>{ setTotalPayout(res.data.result)},()=>{}))
        dispatch(getTotalInvoiceOverdueApi(data,(res)=>{ setTotalInvoiceOverdue(res.data.result.Amount)},()=>{}))




        dispatch(getTotalAgreementExpireApi(data,()=>{},()=>{}))
        dispatch(getTotalHighestPaidInvoiceApi(data,()=>{},()=>{}))
        dispatch(getTotalPayout6MonthApi(data,(res)=>{
         
       setCategories(  res.data.result.map(item => ({
        
        name: item.Category,
        data: item.MonthWiseData.map(data => data.Amount)
      })))
    var monthArr = (res.data.result.flatMap(item =>
        item.MonthWiseData.map(data => data.Month)
      ))

      const uniqueMonths = [...new Set(monthArr)];
      setMonths(uniqueMonths)
            // res.data.result(item => {
               
            //     item.MonthWiseData.map((data,index) => {
                   
            //      if(index == 0){
            //         months.push(data.Month);
            //      }
            //     //   amounts.push(data.Amount);
            //     });
            //   });

        },()=>{}))

    },[])
    const widgetChart = [
        {
            id: 1, price: '65,123', bgcolor: 'rgba(23, 90, 169, 0.78)', nameVal: "Add Invoices", link: "/addInvoice", show: true, icon: "receipt_long"
        },
        { id: 2, price: '75,542', bgcolor: 'rgba(23, 90, 169)', nameVal: "Approved Invoices", link: "/invoiceList?status=Approved", show: true, icon: "task" },
        {
            id: 3, price: '71,321', bgcolor: 'rgb(2 75 161)', nameVal: "Pending Invoices", link: "/invoiceList?status=New", show: true, icon: "pending_actions"
        },
        // { id: 3, price: '40,742', bgcolor: 'rgb(101 168 247)', nameVal: "Electricity Bills", link: "/", show: true, icon: "bolt" },
        // { id: 4, price: '71,321', bgcolor: '#362465', nameVal: "Telephonic Bills", link: "/", show: true, icon: "call" },
        {
            id: 4, price: '1,321', bgcolor: 'rgba(23, 90, 169)', nameVal: "Register Properties", link: "/registerProperty", show: true, icon: "domain_add"
        },
        {
            id: 5, price: '1,321', bgcolor: 'rgba(23, 90, 169)', nameVal: "Invoice Verification", link: "/invoiceVerification", show: true, icon: "domain_add"
        },

    ];
    // Extract actions from the first menu item
const actionsFromResponse = permissions?.filter(menuItem => menuItem.MenuItemName === "DashBoard")?.flatMap(menuItem => menuItem?.Actions);
const nameValToActionMap = {
    "Add Invoices": "AddInvoice",
    "Approved Invoices": "ApprovedInvoices",
    "Pending Invoices": "PendingInvoices",
    "Register Properties": "RegisterProperties",
    "Invoice Verification": "InvoiceVerification"
  };
  const filteredWidgetChart = widgetChart?.filter(item => actionsFromResponse?.includes(nameValToActionMap[item?.nameVal]));

    const widgetChartTop = [
        {
            id: 1, price: totalPayout, bgcolor: 'rgba(23, 90, 169)', nameVal: "Total Payout", link: "", show: true,icon: "currency_rupee"
        },
        { id: 2, price: totalPendingForApproval, bgcolor: 'rgba(23, 90, 169)', nameVal: "Pending Approval", link: "/invoiceList", show: true,icon: "pending_actions" }
        ,
        { id: 3, price:totalPayable, bgcolor:  'rgba(23, 90, 169)', nameVal: "Total Payable", link: "/", show: true, icon: "currency_rupee" },
        { id: 4, price: totalinvoiceOverdue, bgcolor: 'red', nameVal: "Invoice Overdue", link: "/", show: true, icon: "receipt_long" },

    ];
    const navigateUser=(nav)=>{
if(nav==="/registerProperty"){
    dispatch(setPropertyRegData(null))
navigate(nav)
    }else{
        navigate(nav)
    }
    }
    return (
        <>
            <div className="row">
                <div className="col-xl-12">
                    <div className="row">
                        {widgetChartTop.map((item, ind) => (
                            item.show && <div className="col-xl-3 col-lg-6 col-sm-6" key={ind} onClick={() => {
                                if (item.id == 2) {
                                    dispatch(setInvoiceListTab(2))
                                } else if (item.id == 5) {
                                    dispatch(setInvoiceListTab(1))
                                }
                                navigate(item.link)
                            }}>
     <Box
      className="card"
      sx={{ borderRadius: '0px', border: '1px solid lightgray', flexDirection: 'row', minHeight: '80px' ,cursor:item.id===2?"pointer":'default'      }}
    >
      <Grid container alignItems="center">
        <Grid item xs={2} sm={1} md={1} lg={1} xl={1}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              padding: '12px',
              position: 'relative',
              bottom: '22px',
              width: '56px',
              backgroundColor: item.bgcolor,
              left: '6px',
              borderRadius: '10px',
              maxHeight: '50px',
            }}
          >
            <span className="material-icons" style={{ color: 'white' }}>
              {item.icon}
            </span>
          </Box>
        </Grid>
        <Grid item xs={10} sm={11} md={11} lg={11} xl={11}>
          <Box
            className="card-header border-0 d-flex"
            sx={{ paddingLeft: '48px', paddingRight: '10px' }}
          >
            <Box
              className="chart-num-days d-flex align-items-center"
              sx={{ gap: "13px",  }}
            >
              <span className="text-black" style={{ fontSize: '14.5px', fontWeight: '500' }}>
                {item.nameVal}
              </span>
              <span className="text-black">
                {item.id !== 2 ? currencyFormat(item.price) : item.price}
              </span>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
                            </div>
                        ))}

                    </div>
                </div>
                <div className="col-xl-8">
                    <div className="row">
                        <div className="col-xl-12">
                            <div className="card">
                                <div className="card-header">
                                    <div className="d-flex align-items-center">
                                        <i className="fa fa-inr scale-2 text-warning"></i>
                                        <h4 className="heading ms-3 mb-0" style={{ color: 'rgba(23, 90, 169, 0.78)' }}>Bills Details</h4>
                                    </div>
                                </div>
                                <div className="card-body pt-2">
                                    {/* <div className="volume-list">
                                        <div>
                                            <h5>$9,125.00 USD</h5>
                                            <span className="text-danger">-12.04 <i className="fa-sharp fa-solid fa-chevron-down"></i></span>
                                        </div>
                                        <div>
                                            <span className="text-success">High</span>
                                            <h5>9,124.00 USD</h5>
                                        </div>
                                        <div>
                                            <span className="text-danger">Low</span>
                                            <h5>9,124.00 USD</h5>
                                        </div>
                                        <div>
                                            <span className="text-success">24H Volume</span>
                                            <h5>2,124 USD</h5>
                                        </div>
                                    </div> */}
                                    {/* <div id="btcStock"></div> */}
                                    <Graph  category={categories} month={months} amount={amounts}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-xl-4" style={{ zom: '0.9' }}>
                    <div className="card">
                        <div className="card-header">
                            <h4 className="heading mb-0" style={{ color: "rgba(23, 90, 169, 0.78)" }}>Quick Links</h4>
                        </div>
                        <div className="card-body pt-0" >
                            <div className='row' style={{ padding: '15px', gap: '35px', display: 'flex', justifyContent: 'space-around' }}>
                                {filteredWidgetChart.map((item, ind) => (
                                    item.show && <div className='col-3 d-flex flex-column align-items-center ' onClick={() => navigateUser(item.link)} style={{ cursor: "pointer", gap: '10px', padding: '6px', borderRadius: '12px', background: '#d3d3d380', color: 'rgba(23, 90, 169, 0.78)' }}>
                                        <span class="material-icons">
                                            {item.icon}
                                        </span>
                                        <span style={{ textAlign: 'center' }}> {item.nameVal}</span>
                                    </div>
                                ))}






                            </div>




                        </div>
                    </div>
                </div>

            </div>
        </>
    )
}
export default Dashboard3;